var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resume-apply-success-page"},[_c('ResumeApplyDialog',{attrs:{"resumeApplySuccessDialogShow":_vm.resumeApplySuccessDialogShow,"jobId":_vm.jobId,"assessment":_vm.assessment,"resumeApplyData":_vm.resumeApplyData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }